import React, { useEffect, useMemo } from 'react';
import { DateTime } from 'luxon'
import PropTypes from 'prop-types';

import { useCollection, useDocument } from 'react-firebase-hooks/firestore';

import { faker } from '@faker-js/faker';

// @mui
import { Grid, Typography, Paper, styled, Tooltip, Stack, keyframes, useTheme } from '@mui/material';
// components
import { capacity, maxCapacity } from '../../App';
import Checkin from '../../pages/Checkin';
import QueuesService from '../../services/queues.service'
import CheckinsService from '../../services/checkins.service';
import queuescheckin from '../../_mock/queuescheckin';
import { densityColors } from '../../constants';

//

// ----------------------------------------------------------------------


const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const TimeLabel = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "color" && prop !== 'commonProp',
})(({ theme, commonProp, color }) => ({
  backgroundColor: commonProp ? theme.palette.background.primary : "black",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: commonProp ? theme.palette.text.secondary : color
}));

const CapLabel = styled(Paper, {
  shouldForwardProp: (prop) => (prop !== "color" || prop !== "capcolor") && prop !== 'commonProp',
})(({ theme, commonProp, color, capcolor, sec  }) => ({
  backgroundColor: capcolor || theme.palette.background.paper, // theme.palette.mode === 'dark' ? '#1A2027' : '#555',capcolor , // theme.palette.mode === 'dark' ? '#1A2027' : '#555',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  fontSize: commonProp ? 14 : 32,
  animation: commonProp ? '' : `${blink} ${densityColors.length - sec}s linear infinite`,
  color: commonProp ? color : theme.palette.text.primary
}));


export const CheckinFromQueue = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1A2027', // theme.palette.mode === 'dark' ? '#1A2027' : '#080',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: '#080' // "#0F0",
}));


 export const WalkedIn = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1A2027',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: '#FF0' // theme.palette.text.primary,
}));

export const Coming = styled(Paper)(({ theme }) => ({
  backgroundColor: "#1A2027", // theme.palette.mode === 'dark' ? '#1A2027' : '#0F0',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: '#0F0',
}));


export const NoShow = styled(Paper)(({ theme }) => ({
  backgroundColor: '#1A2027', // theme.palette.mode === 'dark' ? '#1A2027' : '#eee',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: "#eee" // theme.palette.text.primary,
}));

CapacityBar.propTypes = {
    time: PropTypes.instanceOf(DateTime),
    current: PropTypes.bool,
    past: PropTypes.bool
}

CapacityBar.defaultProps = {
  time: DateTime.local()
};

export default function CapacityBar({ time, current, past, setLatestCheckins }) {

    const theme = useTheme();
    const [Checkins, loadingCheckins, errorCheckins] = useCollection(CheckinsService.getOfHour(time.valueOf().toString()));
    const [QueuesUser, loadingQueues, errorQueues] = useCollection(QueuesService.getOfHour(time.valueOf().toString()));
    const [CheckedInCount, loadingCheckedInCount, errorCheckedInCount] = useDocument(CheckinsService.getCountOfHour(time.valueOf().toString()))
    const [QueuedCount, loadingQueuedCount, errorQueuedCount] = useDocument(QueuesService.getCountOfHour(time.valueOf().toString()))    

    let checkinsCount = 0
    if (CheckedInCount && CheckedInCount.exists() && CheckedInCount.data().count) checkinsCount = CheckedInCount.data().count


    let queuesCount = 0
    if (QueuedCount && QueuedCount.exists() && QueuedCount.data().count) queuesCount = QueuedCount.data().count

    useEffect(() => {
      const users = Checkins && Checkins.docChanges()
      console.log('users.length', users && users.length);

      if (users && users.length) {
        setLatestCheckins(o => ({
          [DateTime.local().valueOf()]: !o ? users.pop().doc.data() : users.shift().doc.data(),
          // ...o,
        }))
      }

    }, [Checkins, setLatestCheckins]);

    const capqueue = useMemo(() => {


        if (!time) return {} //  || !QueuesUser || (QueuesUser && !QueuesUser.length)



        // DEMO
        // const CheckedInCount = faker.datatype.number({min:0, max:50})
        // const QueuedCount = Math.min(CheckedInCount, capacity)
        // const QueuesUser = queuescheckin
        // const checkins = faker.helpers.arrayElements(queuescheckin, faker.datatype.number({ min:0, max: QueuedCount})) // [4, 2]
        const QueuedUsersCheckedIn = Checkins && Checkins.docs.length  ? QueuesUser && QueuesUser.docs.length ? Checkins.docs.filter(u => QueuesUser.docs.find(qu => qu.id === u.id)
        ) : Checkins : []

        // faker.helpers.arrayElements(QueuesUser || queuescheckin, faker.datatype.number({ min:0, max: QueuedCount})) // [4, 2]

        console.log(checkinsCount - (QueuedUsersCheckedIn.length || 0));

        // const checkinNotQueued = Checkins && Checkins.length  ? QueuesUser && QueuesUser.length ? Checkins.docs.filter(u => QueuesUser.docs.find(qu => qu.data() !== u.data())) : Checkins : []
        // const checkinNotQueued = QueuesUser && QueuesUser.length ? faker.helpers.arrayElements(QueuesUser, faker.datatype.number({min:0, max: (CheckedInCount - QueuedUsersCheckedIn.length)})) : []


        return {
            queues: QueuesUser ? QueuesUser.docs.length : 0,
            checkinFromQueues: QueuedUsersCheckedIn.length,
            coming: queuesCount - QueuedUsersCheckedIn.length,
            walkedin: checkinsCount - (QueuedUsersCheckedIn.length || 0)
        }

    }, [time, Checkins, QueuesUser, checkinsCount, queuesCount])

    const sec = Math.min(densityColors.length - 1, Math.ceil((densityColors.length - 1) *  checkinsCount/ capacity))

    return (<Grid key={time.valueOf()} 
      container 
      spacing={1} 
      borderRadius={{ xs: 2, sm:0}} 
      border={{ xs: 1, sm:0}}  
      borderColor={{ xs:'#000', sm: '#fff00'}}  
      sx={{ p:{xs: 1, sm: 0}, m:{xs: 1, sm: 0}}}
      alignItems={'center'}
    >
    <Grid item xs={6} sm={1} order={0}>
      <TimeLabel commonProp={!current} color={theme.palette.text}>{time.toFormat("HH:mm")}</TimeLabel>
    </Grid>
    <Grid item xs={6} sm={1} order={1}>
      <CapLabel commonProp={!current} sec={sec} capcolor={densityColors[sec]} color={theme.palette.text.primary}>{checkinsCount}</CapLabel>
    </Grid>
    {capqueue.coming ? <Grid item xs={capqueue.coming * 12 / maxCapacity} sm={capqueue.coming * 10 / maxCapacity} order={past ? 4 : 2 }>
    <Tooltip title={`${past ? 'No-show' : 'จองรอบ'} ${capqueue.coming} คน`}>
        {past ? <NoShow><Typography noWrap>{capqueue.coming}</Typography></NoShow> : <Coming><Typography noWrap>{capqueue.coming}</Typography></Coming>}
  </Tooltip>
    </Grid>: <></>}
    {capqueue.checkinFromQueues ? <Grid item xs={capqueue.checkinFromQueues * 12 / maxCapacity} sm={capqueue.checkinFromQueues * 10 / maxCapacity} order={past ? 2 : 3 }>
    <Tooltip title={`เช็คอินรอบจอง ${capqueue.checkinFromQueues} คน`}>
        <CheckinFromQueue><Typography noWrap>{capqueue.checkinFromQueues}</Typography></CheckinFromQueue>
  </Tooltip>
  
    </Grid>: <></>}
    {capqueue.walkedin  ? <Grid item xs={capqueue.walkedin * 12 / maxCapacity} sm={capqueue.walkedin * 10 / maxCapacity} order={past ? 3 : 4 }>
    <Tooltip title={`Walked-in ${capqueue.walkedin} คน`}>
        <WalkedIn><Typography noWrap>{capqueue.walkedin}</Typography></WalkedIn>
  </Tooltip>
  
    </Grid> : <></>}    

    {/* {<p>
        {errorQueues && <strong>Error: {JSON.stringify(errorQueues)}</strong>}
        {loadingQueues && <span>Queues: Loading...</span>}
        {QueuesUser && (
          <span>
            Queues:{' '}
            {QueuesUser.docs.map((doc) => (
                <React.Fragment key={doc.id}>
                  {JSON.stringify(doc.data())},{' '}
                </React.Fragment>
              ))}
          </span>
        )}
      </p>} */}
  </Grid>)
}